import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantEmployeeRules } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useEmployeeRules = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.EMPLOYEE_RULES, orgSlug, restaurantId], () =>
    tenantEmployeeRules({ orgSlug, restaurantId })
  );
};
